export { default as isHTMLAnchorElement } from './typeUtils/isHTMLAnchorElement';
export { default as isHTMLImageElement } from './typeUtils/isHTMLImageElement';
export { isHTMLElement } from 'roosterjs-cross-window';
